import pickBy from "lodash/pickBy";

import { ChildrenTableConfig } from "../nested_table";
import { TableData, TableProps } from "../table";

export const NESTED_ROW_ID_DELIMITER = "_";

type GetFinalChildrenTableConfig<CHILDREN_TABLE_DATA extends TableData> = {
  rowId: string;
  childrenTableConfig: ChildrenTableConfig<CHILDREN_TABLE_DATA>;
  childrenTableData: CHILDREN_TABLE_DATA[];
  childrenTableSorting?: Pick<TableProps<CHILDREN_TABLE_DATA>, "onSortingChange" | "controlledSorting">;
};

export const getFinalChildrenTableConfig = <CHILDREN_TABLE_DATA extends TableData>({
  rowId,
  childrenTableConfig,
  childrenTableData,
  childrenTableSorting
}: GetFinalChildrenTableConfig<CHILDREN_TABLE_DATA>) => {
  const childrenRowSelection = pickBy(childrenTableConfig.rowSelection, (value, key) =>
    key.startsWith(`${rowId}_`)
  );

  const onChildrenRowSelectionChange = (updater) => {
    const newState = typeof updater === "function" ? updater(childrenRowSelection) : updater;
    childrenTableConfig.onRowSelectionChange?.((prevState) => {
      const otherChildrenRowSelectionState = pickBy(
        prevState,
        (value, key) => !key.startsWith(`${rowId}${NESTED_ROW_ID_DELIMITER}`)
      );
      return { ...otherChildrenRowSelectionState, ...newState };
    });
    return newState;
  };

  const getChildrenRowId = (row, index) =>
    `${rowId}${NESTED_ROW_ID_DELIMITER}${childrenTableConfig.getRowId?.(row, index) ?? index}`;

  return {
    ...childrenTableConfig,
    getRowId: getChildrenRowId,
    tableData: childrenTableData,
    isLoading: childrenTableConfig.getIsLoading?.(rowId),
    isLoadingCompact: true,
    onRowSelectionChange: onChildrenRowSelectionChange,
    rowSelection: childrenRowSelection,
    enableSorting: true,
    onSortingChange: (sorting) => {
      childrenTableSorting?.onSortingChange?.(sorting);
    },
    controlledSorting: childrenTableSorting?.controlledSorting
  };
};
